import { Component, ChangeDetectionStrategy } from "@angular/core";
import { BankAccountService } from "app-service";
import { Button } from "app-core";

import ButtonType = Data.Core.ButtonType;

@Component({
	selector: 'app-product-presentation-sales',
	templateUrl: './product-presentation-sales.component.html',
	styleUrls: ['./product-presentation-sales.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	viewProviders: [BankAccountService]
})
export class ProductPresentationSalesComponent {
	public downloadButton: Button = new Button({
		label: 'Download',
		type: ButtonType.button,
		action: () => {
			const link = document.createElement('a');
			link.href = this.productDemoURL;
			link.download = `https://www.sales.arogyaline.com/assets/ArogyaLine - Sales.pptx`; // Optional: suggest filename
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	});
	public loading: boolean = true;
	public productDemoURL: string = `https://www.sales.arogyaline.com/assets/ArogyaLine - Sales.pptx`;

	public ngAfterViewInit(): void {
		const iframe = document.querySelector('iframe');
		if (iframe) {
			iframe!.onload = () => {
				const iframeDoc = iframe?.contentDocument || iframe?.contentWindow?.document;
				if (iframeDoc) {
					const style = iframeDoc.createElement('style');
					style.textContent = `[role="document"] { padding-top: 5em; }`;
					iframeDoc.head.appendChild(style);
				}
			};
		}
	}

	public onDocLoaded(): void {
		this.loading = false;
	}
}
